document.addEventListener('click', (event) => {
  const facade = event.target.closest('[data-siokiuu-youtube-facade]');
  if (!facade || facade.dataset.youtubeLoaded === 'true') return;

  const media = facade.closest('.siokiuu-independent-reviews__media');
  const videoId = facade.dataset.youtubeId;
  if (!media || !videoId) return;

  const parameters = new URLSearchParams({ autoplay: '1', rel: '0' });
  if (facade.dataset.youtubeStart) parameters.set('start', facade.dataset.youtubeStart);

  const iframe = document.createElement('iframe');
  iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?${parameters.toString()}`;
  iframe.title = facade.dataset.youtubeTitle || 'YouTube video';
  iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  iframe.allowFullscreen = true;
  media.replaceChildren(iframe);
  facade.dataset.youtubeLoaded = 'true';
});
